import { lighten } from '@mui/material/styles';
import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: lighten(theme.colors.primary.main, 0.9),
        },
    },
}));
//# sourceMappingURL=ListItem.styles.js.map